module.exports = __webpack_public_path__ + "img/icon2.bf99b68b.jpg";